"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmenitySection = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const accordion_1 = require("../accordion");
const Button_1 = require("../button/Button");
const AmenityItem_1 = require("./AmenityItem");
const children_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/children.svg"));
const featured_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/featured.svg"));
const health_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/health.svg"));
const heating_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/heating.svg"));
const kitchen_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/kitchen.svg"));
const linen_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/linen.svg"));
const location_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/location.svg"));
const outdoors_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/outdoors.svg"));
const security_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/security.svg"));
const tech_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/tech.svg"));
const view_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/view.svg"));
const accessibility_svg_1 = __importDefault(require("../../../92b3b47/assets/images/amenities/accessibility.svg"));
const ButtonWrapper = styled_1.default.div `
	margin-bottom: 20px;
`;
const ImageWrap = styled_1.default.span `
	margin-right: 10px;
	width: 40px;
	height: 40px;
	background-color: ${merlin_theme_1.default.palette.blue.primary};
	border-radius: 50%;
`;
const Image = styled_1.default.img `
	width: 20px;
	height: 20px;
	margin-top: 10px;
	margin-left: 10px;
`;
const icons = {
    'children': children_svg_1.default,
    'featured': featured_svg_1.default,
    'health': health_svg_1.default,
    'heating': heating_svg_1.default,
    'kitchen': kitchen_svg_1.default,
    'linen': linen_svg_1.default,
    'location': location_svg_1.default,
    'outdoors': outdoors_svg_1.default,
    'security': security_svg_1.default,
    'tech': tech_svg_1.default,
    'view': view_svg_1.default,
    'accessibility': accessibility_svg_1.default,
};
const generateSubHeading = (amenities) => {
    const selected = amenities.filter(amenity => amenity.selected);
    return `${selected.length} ${selected.length === 1 ? 'amenity' : 'amenities'} selected`;
};
const AmenitySection = ({ id, title, amenities, onCheckboxClick, onOptionClick, onSelectAllClick, }) => {
    return (React.createElement(accordion_1.Accordion, null,
        React.createElement(accordion_1.AccordionHeader, { icon: () => React.createElement(ImageWrap, null,
                React.createElement(Image, { src: icons[id] })) },
            React.createElement(accordion_1.DefaultAccordionHeading, { heading: title, subheading: generateSubHeading(amenities) })),
        React.createElement(accordion_1.AccordionItem, { noBorder: true },
            title === 'Accessibility' &&
                React.createElement(merlin_info_panels_1.DidYouKnow, { colour: "yellow", id: "wheelchair-access-info-amenities-page", text: "Please select the wheelchair access amenity only if you meet all of the standards as required by applicable law.", widthOverride: "100%" }),
            React.createElement(ButtonWrapper, null,
                React.createElement(Button_1.Button, { "data-testid": `${title}-amenity-section-select-all`, onClick: () => onSelectAllClick(amenities.map((a) => (Object.assign(Object.assign({}, a), { selected: true })))) }, "Select all")),
            amenities.map((amenity, idx) => (React.createElement(AmenityItem_1.AmenityItem, { amenity: amenity, key: `amenity-item-${idx}`, onCheckboxClick: onCheckboxClick, onOptionClick: onOptionClick }))))));
};
exports.AmenitySection = AmenitySection;
//# sourceMappingURL=AmenitySection.js.map